import { useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm, type DeepPartial, type UseFormReturn } from 'react-hook-form';
import type * as yup from 'yup';

import styles from './form.module.css';

interface ISubmitModulesForm<T> {
  children: React.ReactNode;
  schema?: yup.ObjectSchema<DeepPartial<T>>;
  submit?: (data: T, methods: UseFormReturn<DeepPartial<T>, any, undefined>) => void;
  defaultValue?: any;
  values?: any;
  className?: string;
  /**
   * When true, stops submit events from bubbling to ancestor forms. Useful for nested/modal forms.
   */
  stopParentSubmit?: boolean;
}

export function AppFormProvider<T>({
  children,
  submit,
  defaultValue,
  schema,
  values,
  className,
  stopParentSubmit = false,
}: ISubmitModulesForm<T>) {
  const currentMethods = useForm({
    defaultValues: defaultValue ?? {},
    values: values,

    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: schema ? yupResolver(schema) : undefined,
  });

  // If parent passes `values` to update the form data after mount, reset the form
  // to avoid merging or duplicating field arrays. This ensures react-hook-form
  // replaces the form state instead of appending to arrays.
  // useEffect(() => {
  //   if (values) {
  //     try {
  //       // If the incoming values contain a `fields` array, dedupe by `id` to
  //       // avoid duplicated entries when values are reset after a server refetch.
  //       const incoming: any = values;
  //       if (Array.isArray(incoming.fields)) {
  //         const seen = new Set<string>();
  //         const deduped = [] as any[];
  //         for (let i = 0; i < incoming.fields.length; i++) {
  //           const item = incoming.fields[i];
  //           const id = item && (item.id ?? item.fieldName ?? i);
  //           if (id == null) {
  //             deduped.push(item);
  //             continue;
  //           }
  //           if (!seen.has(id)) {
  //             seen.add(id);
  //             deduped.push(item);
  //           }
  //         }

  //         const newValues = { ...incoming, fields: deduped } as DeepPartial<T>;
  //         currentMethods.reset(newValues);
  //       } else {
  //         currentMethods.reset(values as DeepPartial<T>);
  //       }
  //     } catch (err) {
  //       // swallow reset errors but log for debugging
  //       // eslint-disable-next-line no-console
  //       console.error('Error resetting form values', err);
  //     }
  //   }
  //   // We intentionally only watch `values` for resets.
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [values]);

  return (
    <form
      onSubmit={
        submit
          ? currentMethods.handleSubmit(
              (data) => submit(data, currentMethods),
              (error) => console.error(error)
            )
          : undefined
      }
      onSubmitCapture={stopParentSubmit ? (e) => e.stopPropagation() : undefined}
      className={className}
    >
      <FormProvider {...currentMethods}>{children}</FormProvider>
    </form>
  );
}

export const formStyles = styles;
